var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"sample-status"},[(_vm.type === 'string')?_c('span',[_vm._v(_vm._s(_vm.str))]):(_vm.type === 'label')?_c('el-tag',{attrs:{"size":"small","type":_vm.color}},[_vm._v(_vm._s(_vm.str))]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }